












import Vue from 'vue';
import recognition from '../../auth/recognition';
import { AccountSubscriber, UserSubscriptionsElement } from '../../types';
import SubscribeToAccountsBtn from './SubscribeToAccountsBtn.vue';
import UserSubscriptions from './UserSubscriptions.vue';

export default Vue.extend({
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  computed: {
    isClient(): boolean {
      return recognition.isClient();
    },
  },
  methods: {
    add(subscribers: AccountSubscriber[]): void {
      (this.$refs.userSubscriptions as UserSubscriptionsElement).add(subscribers);
    },
  },
  components: {
    SubscribeToAccountsBtn,
    UserSubscriptions,
  },
});
